export const ordinal = (n) => `${n}º`;

export const labelCiclo = (n) => n ? `${ordinal(n)} Ciclo` : '—';
